import api from "./api";
import { toast } from "react-toastify";

const header = () => ({
  Authorization: "Bearer " + localStorage.getItem("token"),
  "Content-Type": "application/json",
});

function catcherror(error) {
  if (error.code === 'ECONNABORTED' || (error.message && error.message.toLowerCase().includes('timeout'))) {
    return;
  }
  if (error.response?.status === 401) {
    localStorage.clear();
    window.location.href = "/";
  } else {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
}

export async function rfidCardList(type, academy) {
  try {
    return await api
      .get(`/rfidcardlist/${type}/${academy}`, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidCardDetail(id) {
  try {
    return await api
      .get(`/rfidcarddetail/${id}`, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidCardCreate(data) {
  try {
    return await api
      .post("/rfidcardcreate", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidCardUpdate(data) {
  try {
    return await api
      .post("/rfidcardupdate", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidCardDelete(data) {
  try {
    return await api
      .post("/rfidcarddelete", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidCardScan(data) {
  try {
    return await api
      .post("/rfidcardscan", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidLogList(data) {
  try {
    return await api
      .post("/rfidloglist", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidLookupUser(data) {
  try {
    return await api
      .post("/rfidlookupuser", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidManualAttendance(data) {
  try {
    return await api
      .post("/rfidmanualattendance", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidPopulateFromIdCards(data) {
  try {
    return await api
      .post("/rfidpopulatefromidcards", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}

export async function rfidUserSearch(data) {
  try {
    return await api
      .post("/rfidusersearch", data, { headers: header() })
      .then((r) => r.data)
      .catch(catcherror);
  } catch (e) {
    catcherror(e);
  }
}
